import { HttpClient } from '../shared/api/HttpClient';
import type { Incident, ServerSummary, StationHealth } from './types';

interface Page<T> { items: T[] }

export class MonitoringApi {
  readonly #http = new HttpClient({ readCsrfToken: readCsrfCookie });

  public async login(email: string, password: string): Promise<void> {
    await this.#http.request('/auth/login', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, password }),
    });
  }

  public server(): Promise<ServerSummary> { return this.#http.request('/monitoring/server'); }
  public async stations(): Promise<StationHealth[]> { return (await this.#http.request<Page<StationHealth>>('/monitoring/stations')).items; }
  public async incidents(includeResolved = false): Promise<Incident[]> {
    return (await this.#http.request<Page<Incident>>(`/incidents?includeResolved=${includeResolved ? '1' : '0'}`)).items;
  }
  public acknowledge(id: string): Promise<Incident> { return this.#http.request(`/incidents/${id}/acknowledge`, { method: 'POST' }); }
  public resolve(id: string): Promise<Incident> {
    return this.#http.request(`/incidents/${id}/resolve`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ reason: 'MANUAL_VERIFIED' }),
    });
  }
  public restoreAuto(id: string): Promise<Incident> { return this.#http.request(`/incidents/${id}/restore-auto`, { method: 'POST' }); }
}

function readCsrfCookie(): string | null {
  const prefix = '__Host-radio_csrf=';
  const value = document.cookie.split(';').map((part) => part.trim()).find((part) => part.startsWith(prefix));
  return value === undefined ? null : decodeURIComponent(value.slice(prefix.length));
}
